import { captureExceptionSafe } from '../utils/captureExceptionSafe';
import { setTokens } from '../utils/tokens';
import instance from './scorpiusInstance';
import {
  REFRESH_USER_TOKEN_START,
  REFRESH_USER_TOKEN_SUCCESS,
  REFRESH_USER_TOKEN_ERROR,
} from './types';

export const refreshUserTokenStart = () => ({
  type: REFRESH_USER_TOKEN_START,
});

export const refreshUserTokenSuccess = token => ({
  type: REFRESH_USER_TOKEN_SUCCESS,
  token,
});

export const refreshUserTokenError = error => ({
  type: REFRESH_USER_TOKEN_ERROR,
  error,
});

export const refreshUserToken = refresh_token => async dispatch => {
  dispatch(refreshUserTokenStart());
  try {
    const response = await instance.post('/user/api-token-auth/refresh', {
      refresh_token,
    });

    const { token, refresh_token: newRefreshToken } = response.data;

    // Save the new set of tokens - use new refresh_token from response if provided
    const newTokens = {
      token,
      refresh_token: newRefreshToken || refresh_token,
    };
    setTokens(newTokens);

    // Update the scorpius instance with new Bearer token
    instance.defaults.headers.Authorization = `Bearer ${token}`;

    return dispatch(refreshUserTokenSuccess(token));
  } catch (error) {
    captureExceptionSafe(error, {
      tags: {
        component: 'refresh-user-token',
        operation: 'manual-token-refresh-failed',
      },
      extra: {
        errorStatus: error?.response?.status,
        errorMessage: error?.message,
        hasRefreshToken: Boolean(refresh_token),
      },
    });
    throw dispatch(refreshUserTokenError(error));
  }
};

export default refreshUserToken;
